import { render, staticRenderFns } from "./DetailMainPage.vue?vue&type=template&id=174ed7ec&scoped=true"
import script from "./DetailMainPage.vue?vue&type=script&lang=js"
export * from "./DetailMainPage.vue?vue&type=script&lang=js"
import style0 from "./DetailMainPage.vue?vue&type=style&index=0&id=174ed7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ed7ec",
  null
  
)

export default component.exports